import { render, staticRenderFns } from "./PublicationsNew.vue?vue&type=template&id=0e2dce14&scoped=true&"
import script from "./PublicationsNew.vue?vue&type=script&lang=js&"
export * from "./PublicationsNew.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsNew.vue?vue&type=style&index=0&id=0e2dce14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2dce14",
  null
  
)

export default component.exports